import ApplyLeaveAdminActionType from './ApplyLeaveAdmin.types';

export const applyLeaveAdminStart = (leaveData: any) => ({
	type: ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_START,
	payload: leaveData,
});

export const applyLeaveAdminSuccess = (leaveData: any) => ({
	type: ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_SUCCESS,
	payload: leaveData,
});

export const applyLeaveAdminFailure = (error: unknown) => ({
	type: ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_FAILURE,
	payload: error,
});

export const applyLeaveAdminResponseChanged = () => ({
	type: ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_RESPONSE_CHANGED,
});

export const applyLeaveAdminResponseRestStart = () => ({
	type: ApplyLeaveAdminActionType.APPLY_LEAVE_ADMIN_RESPONSE_REST_START,
});

export const getAllEmployeesAdminStart = (organisationData: any) => ({
	type: ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_START,
	payload: organisationData,
});

export const getAllEmployeesAdminSuccess = (employeesData: any) => ({
	type: ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_SUCCESS,
	payload: employeesData,
});

export const getAllEmployeesAdminFailure = (error: unknown) => ({
	type: ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_FAILURE,
	payload: error,
});

export const getAllEmployeesAdminResponseChanged = () => ({
	type: ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_RESPONSE_CHANGED,
});

export const getAllEmployeesAdminResponseRestStart = () => ({
	type: ApplyLeaveAdminActionType.GET_ALL_EMPLOYEES_ADMIN_RESPONSE_REST_START,
});
